import { BaseState } from '@/store/base-state';
import { Filters, TableOptions } from '@/types';
import { DataPilot } from '@/modules/data-pilot/types';

export class ReasonsCommunicationState extends BaseState {
  addresses: string[] = [];
  events: DataPilot.Event[] = [];

  filters: Filters = {
    search: '',
    tag_ids: [],
    event_status_ids: [],
    priority_ids: [],
    period: [],
    event_ids: [],
    responsible_event_ids: [],
    model_ids: [],
    addresses: [],
    client_ids: [],
    current_events: true,
  };

  client_events: DataPilot.ClientEvent[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  loading = false;
}
